export const STORE = {
  name: "Guna Stores",
  address: "4 Crosslances Road, Hounslow, TW3 2AA",
  phone: "[Phone number]",
  email: "[Email address]",
  hours: [
    { day: "Monday – Sunday", time: "7:00am – 10:00pm" },
  ],
};

export const CATEGORIES = ["All", "Wine", "Beer & Cider", "Spirits", "Soft drinks", "Snacks", "Essentials"];

export const slug = (s) => s.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "");

export const gbp = (n) => `£${Number(n ?? 0).toFixed(2)}`;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
